import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { InputError, InputWarning } from '../Alert/Alert';
import { forwardDataAttributes } from '../util/getDataAttributes';
import { StyledFieldError, StyledFieldErrorMessage } from './FieldError.styled';
export function FieldError(props) {
  var id = props.htmlFor && "".concat(props.htmlFor, "-error");
  var errorRef = React.useRef(null);
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    offset = _React$useState2[0],
    setOffset = _React$useState2[1];
  React.useEffect(function () {
    if (!offset && (props.error || props.warning)) {
      var _errorRef$current$get, _errorRef$current;
      var elementHeight = (_errorRef$current$get = (_errorRef$current = errorRef.current) === null || _errorRef$current === void 0 ? void 0 : _errorRef$current.getBoundingClientRect().height) !== null && _errorRef$current$get !== void 0 ? _errorRef$current$get : 0;
      setOffset(elementHeight);
    } else if (offset && !props.error && !props.warning) {
      setOffset(0);
    }
  }, [offset, props.error, props.warning]);
  return /*#__PURE__*/React.createElement(StyledFieldError, {
    id: id,
    style: props.style
  }, /*#__PURE__*/React.createElement(StyledFieldErrorMessage, {
    "data-testid": "field-error-wrapper",
    elementOffset: offset,
    ref: errorRef
  }, props.error ? /*#__PURE__*/React.createElement(InputError, _extends({
    action: props.alertAction
  }, forwardDataAttributes(props)), props.error) : props.warning && /*#__PURE__*/React.createElement(InputWarning, _extends({
    action: props.alertAction
  }, forwardDataAttributes(props)), props.warning)));
}